module.exports = __webpack_public_path__ + "static/media/FlowDeliver.de14d035.svg";